import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../../hooks/useApi';
import { BillingCycleRes } from '../rtm_plan/index.type';

export interface IState{
key:string,
value:string
}

const useFetchAllProcess= () => {
    const [processType, setProcessType] = React.useState<IState[]>([]);

    
    const { loading:processTypeLoading, makeApiCall } = useApi({
      url: `/rtm/billing-cycle/type`,
      method: 'GET',
    });
  
    const getProcessType= async () => {
      const { response, error } = await makeApiCall<undefined, BillingCycleRes>();
      
      if (response?.status === 'success') {
      
       setProcessType(response.data);
        
      }
  
      if (error) toast.error('Something went wrong while billing cycle. Please try again later');
      return [];
    };
  
    return {
     processType,
       getProcessType,
     processTypeLoading,
    };
  };
  
export default useFetchAllProcess;